import { AuthorMini } from "../../shared/models/Author";
import { DataRelatedBuilder } from "./DataRelatedBuilder";
import { EditorialMessageContent } from "./EditorialMessageContent";
import { MessageContent } from "./MessageContent";
import { SignalI3 } from "./SignalI3";

export class SignalDataRelatedBuilder implements DataRelatedBuilder<SignalI3> {
    build(relatedContent: SignalI3, content: EditorialMessageContent, author: AuthorMini = null): MessageContent {
        content.relatedSignalContent = {
            PositionMaintenanceId: relatedContent.positionMaintenanceId,
            StrategyId: relatedContent.strategyId,
            StrategyFancyName: relatedContent.strategyFancyName,
            SideType: relatedContent.getSide(),
            Asset: relatedContent.asset,
            Pips: relatedContent.pips,
            EntryPrice: relatedContent.entryPrice,
            OpenUtc: relatedContent.openingTimeUtc,
            CloseUtc: relatedContent.closingTimeUtc,
            StopLoss: relatedContent.stopLoss,
            TakeProfit: relatedContent.takeProfit,
            StrategyFancyType: relatedContent.strategyFancyType,
            ProfitPercent: relatedContent.profitPercent
        };
        content.relatedRecordingContent = null;
        content.relatedWebinarContent = null;
        content.relatedPostContent = null;
        content.relatedCalendarEventContent = null;
        return content;
    }
}


// WEBPACK FOOTER //
// ./src/app/tradingstudio/models/SignalDataRelatedBuilder.ts